const { version } = require('../package.json');

module.exports = {
    APISERVICE : process.env.VUE_APP_APISERVICE,
    URLIMAGE: process.env.VUE_APP_URLIMAGE,
    APP_VERSION: version
  }